import {
    AuthComponent,
    HomePage,
    ProfilePage,
    // TickerDetailPage,
    Error400,
    Error401,
    Error403,
    Error404,
    Error500,
    Error503,
} from "./containers";

const routes = [
    {
        path: '/',
        exact: true,
        component: HomePage,
        protected: true,
        default: false,
    },
    {
        path: '/profile',
        exact: true,
        component: ProfilePage,
        protected: true,
        default: false,
    },
    {
        path: '/change-password',
        exact: true,
        component: ProfilePage,
        protected: true,
        default: false,
    },
    // {
    //     path: '/ticker/:id',
    //     exact: true,
    //     component: TickerDetailPage,
    //     protected: true
    // },
    {
        path: '/login',
        exact: true,
        component: AuthComponent,
        protected: false,
        default: true
    },
    {
        path: '/forgot',
        exact: true,
        component: AuthComponent,
        protected: false,
        default: false,
    },
    {
        path: '/reset',
        exact: true,
        component: AuthComponent,
        protected: false,
        default: false,
    },
    {
        path: '/401',
        exact: false,
        component: Error401,
        protected: false,
        default: false,
    },
    {
        path: '/403',
        exact: false,
        component: Error403,
        protected: false,
        default: false,
    },
    {
        path: '/404',
        exact: false,
        component: Error404,
        protected: false,
        default: false,
    },
    {
        path: '/500',
        exact: false,
        component: Error500,
        protected: false,
        default: false,
    },
    {
        path: '/503',
        exact: false,
        component: Error503,
        protected: false,
        default: false,
    },
    {
        path: '*',
        exact: false,
        component: Error400,
        protected: false,
        default: false,
    },
]

export default routes;